import { Button, TextField } from '@material-ui/core';
import React, { FC } from 'react';
import SearchIcon from '@material-ui/icons/Search';

interface Props {
  value: string;
  fullWidth?: boolean;
  onChangeValue: (event: any) => void;
  handleSearch: (val: string) => void;
}

export const DrawerSearchBox: FC<Props> = ({
  value,
  fullWidth = false,
  onChangeValue,
  handleSearch
}) => {
  return (
    <>
      <TextField
        variant="outlined"
        value={value}
        placeholder="Search Page"
        onChange={onChangeValue}
        style={{ ...(fullWidth && { width: '100%' }) }}
        onKeyDown={(e) => e.key === 'Enter' && handleSearch(value)}
        size="small"
        InputProps={{
          endAdornment: (
            <Button
              color="primary"
              variant="contained"
              style={{
                position: 'absolute',
                right: 0,
                height: '100%'
              }}
              onClick={() => handleSearch(value)}
            >
              <SearchIcon />
            </Button>
          )
        }}
      />
    </>
  );
};
